module.exports = __webpack_public_path__ + "img/chr_ts_8_penlight.9586be9c.png";